import React from "react";
import { Button, Icons, Tabs, useDevice } from "@pushpress/shared-components";
import { useToggle } from "../../../hooks/state";
import { Member } from "../../../apis/userApi";
import CreditsModal from "../CreditsModal";
import BookAppointmentDrawer from "../BookAppointmentDrawer/BookAppointmentDrawer";
import { getCompleteName } from "../../../utils/misc";
import { getBackText } from "./AppointmentCredits.utils";
import styles from "./AppointmentCreditsHeader.module.scss";
import { MemberFragment } from "./AppointmentCredits-generated.hooks";

interface AppointmentCreditsHeaderProps {
  memberId: string;
  profile?: MemberFragment;
  activeTab: number;
  onTabChange: (tab: number) => void;
  onCreditsSuccess: VoidFunction;
  onBookingSuccess: VoidFunction;
}

function AppointmentCreditsHeader(props: AppointmentCreditsHeaderProps) {
  const {
    memberId,
    profile,
    activeTab,
    onTabChange,
    onCreditsSuccess,
    onBookingSuccess,
  } = props;

  const { isMobile } = useDevice();

  const [creditsVisible, creditsActions] = useToggle(false);
  const [bookingVisible, bookingActions] = useToggle(false);

  const backText = getBackText(profile);
  const buttonSize = isMobile ? "medium" : "large";
  const member = {
    uuid: profile?.userUuid,
    name: getCompleteName(profile?.firstName, profile?.lastName),
  } as Member;

  return (
    <>
      <div className={styles.root}>
        <div className={styles.back}>
          <Button
            href={`/members/view/${memberId}`}
            buttonType="text"
            text={backText}
            icon={Icons.ArrowLeft}
            iconLocation="left"
          />
        </div>
        <div className={styles.actions}>
          <Button
            aria-label="Add credits"
            text="Credits"
            icon={Icons.Plus}
            iconLocation="left"
            buttonType="secondary"
            size={buttonSize}
            onClick={creditsActions.on}
          />
          <Button
            text="Book appointment"
            icon={Icons.Plus}
            iconLocation="left"
            buttonType="primary"
            size={buttonSize}
            onClick={bookingActions.on}
          />
        </div>
        <div className={styles.nav}>
          <Tabs
            className={styles.tabs}
            tabHeaders={["Credits", "Appointments"]}
            selectedIndex={activeTab}
            changeTab={onTabChange}
            align="left"
          />
        </div>
      </div>
      <CreditsModal
        visible={creditsVisible}
        onClose={creditsActions.off}
        userUuid={memberId}
        onSuccess={() => {
          onCreditsSuccess();
          creditsActions.off();
        }}
      />
      <BookAppointmentDrawer
        visible={bookingVisible}
        defaultValues={{ member }}
        onClose={bookingActions.off}
        onSuccess={() => {
          onBookingSuccess();
          bookingActions.off();
        }}
      />
    </>
  );
}

export default AppointmentCreditsHeader;
